



import React, { useState } from "react";
import Loader from "react-loader-spinner";
import NotificationAlert from "react-notification-alert";

import {

  Row,
  Form

  
} from 'reactstrap';








class Uploader extends React.Component {
   
  constructor(props) {
      super(props);

    
      this.state = {
        fileData:"",
        loading:false
      };
    }


     getFile = (e) => {

      if (e.target.files[0].size < 10485760) {


      this.setState({fileData:e.target.files[0]})

      }

      else {
        
        this.setState({fileData:''})

        
        this.notify('danger' ,'Sorry! Maximum File Size is 10 MB, Please Choose another File');
      

      
      }


    };
  


    notify = (typee , msg) => {
      var options = {};
      options = {place: 'tc',message: (<div><div> {msg}</div></div>  ),type: typee,icon: "now-ui-icons ui-1_bell-53",autoDismiss: 7,}
      this.refs.notificationAlert.notificationAlert(options);
    }
    
  






    uploadFile = (e) => { 
      e.preventDefault();   
  
      let d = new Date();
      let month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      
      let date = d.getDate() + " " + month[d.getMonth()] + ", " + d.getFullYear();
      let time = d.toLocaleTimeString().toLowerCase();
      
      var hour = d.getHours();
      var min = d.getMinutes();
      var sec = d.getSeconds();
      
if (this.state.fileData.size < 10485760) {

      const data = new FormData();
      var newFileName = `${date}-${hour}-${min}-${sec}-${this.state.fileData.name}`
  
      data.append("file", this.state.fileData, newFileName );
  

      this.setState({loading:true})
    


          
          this.setState({fileData:'',loading:false})

          setTimeout( () => { this.notify('info' , 'File Uploaded'); }, 500);



    }

else {this.notify('danger' ,'Sorry! Maximum File Size is 10 MB, Please Choose another File');}


  
    };




render(){







return (

   this.state.loading ? 
    <Row className="justify-content-center align-items-center" >
  <NotificationAlert ref="notificationAlert" />

  <Loader
          type="Puff"
          color="rgb(101, 153, 57)"
          height={100}
          width={100}
          timeout={60000} //3 secs
        /></Row>
:
  <div>
<NotificationAlert ref="notificationAlert" />


  <form onSubmit={this.uploadFile}>
  <strong>Attach File</strong><span> (Max 10 Megabytes)</span>
  <br/><br/>
  <input type="file" name="file" onChange={this.getFile} required />
  {this.props.submitexist ?   <input type="submit" name="upload" value="Upload" />
:null}
</form>
  </div>

);
}
}




export default Uploader;


